import { getLayout } from "@components/common/Layout";
import Mobile from "components/ui/search/Tab/mobile";
import React from "react";

const Filter = () => {
  return <Mobile />;
};

Filter.getLayout = (page: any) => getLayout(page, { footer: false });

export default Filter;
